<div class="app-progress-bar" [style.height.px]="height">
  <div
    class="app-progress-bar__fill"
    [style.width]="widthPercent"
    [style.background]="displayColor"
    [style.height.px]="height"
  ></div>
</div>
